<template>
  <el-dialog
          :visible.sync="state"
          :append-to-body="true"
          :item="item"
          custom-class="kashira-item-select">
    <v-kashira-item-list @element-click2="elementBtnClicked"
                         v-if="selectedItem == null" :item="item"/>
  </el-dialog>
</template>



<script>
  import {
    Dialog,
  } from 'element-ui'
  import 'element-ui/lib/theme-chalk/dialog.css'
  import 'element-ui/lib/theme-chalk/icon.css'

  export default {
    components: {
      'el-dialog': Dialog,
      'v-kashira-item-list': require('@/components/kashira-item-list.vue').default,
    },
    props: {
      selectedItem: null,
      item: Object,
      value: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    computed: {
      state: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
    },
    methods: {
      elementBtnClicked: function (e, faceProduct) {
        this.selectedItem = faceProduct;
        this.$emit('faceProductSelected', e, this.selectedItem)
      },
      cancelSelectedItem: function () {
        this.selectedItem = null;
      }
    }
  }
</script>



<style lang="scss">
  .kashira-item-select {
    width: 608px;

    .el-dialog {
      &__body {
        padding: 0;
        @include breakpoints-min(md) {
          padding: 32px 0;
        }
      }
    }
  }

  .kashira-item-select__item {
    $e: &;
    display: block;
    transition: $transition;
    position: relative;
    z-index: 1;
    border-top: 1px solid $oc-gray-2;
    background-color: #fff;
    width: 100%;
    padding: 16px;
    margin-top: 28px;
    &:last-child {
      border-bottom-left-radius: 2px;
      border-bottom-right-radius: 2px;
    }
    @include active() {
      z-index: 2;
      box-shadow: 0 8px 17px 2px rgba(#000, 0.07), 0 3px 14px 2px rgba(#000, 0.06), 0 0 5px -3px rgba(#000, 0.1);
      border-top-color: transparent;
      & + #{$e} {
        border-top-color: transparent;
      }
    }
    @include breakpoints-min(md) {
      border-top: none;
      width: 548px;
      margin: 0 32px;
      padding: 0 0 50px 0;
      text-align: center;
      &:last-child {
        border-bottom: none;
      }
      @include active() {
        box-shadow: none;
      }
    }
    &.is-active {
      box-shadow: none;
      background-color: #fff2f4;
      #{$e}__button {
        border-color: $accent-color;
        background-color: $accent-color;
        color: #fff;
        @include hover() {
          border-color: $accent-color;
          background-color: $accent-color;
          color: #fff;
        }
        @include active() {
          border-color: #826c63;
          background-color: #826c63;
          color: #fff;
        }
        @include breakpoints-min(lg) {
          border-color: #947c72;
          background-color: #947c72;
          @include hover() {
            border-color: #947c72;
            background-color: #947c72;
            color: #fff;
          }
          @include active() {
            border-color: #826c63;
            background-color: #826c63;
            color: #fff;
          }
        }
      }
      #{$e}__enlarge-button {
        &::after {
          background-color: #f1aab7;
        }
        @include breakpoints-min(md) {
          &::after {
            background-color: #d4d2d2;
          }
        }
      }
      .item-img {
        &::after {
          border: 1px solid rgba($accent-color, 0.5);
        }
      }
      @include breakpoints-min(md) {
        background-color: transparent;
      }
    }
    &__body {
      display: block;
      width: calc(100% - 136px);
      padding: 12px 12px 12px 0;
      @include breakpoints-min(md) {
        width: auto;
        padding: 0;
      }
    }
    &__name {
      font-family: $serif;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.3;
      letter-spacing: 0.05em;
      color: #000;
      margin: 0 2px 4px;
      @include breakpoints-min(md) {
        font-size: 15px;
        text-align: center;
        letter-spacing: 0.08em;
        color: #212529;
        margin: 12px 0 12px;
      }
    }
    &__soldout {
      display: inline-block;
      background-color: $accent-color;
      font-family: $sans-serif;
      font-size: 13px;
      color: #fff;
      margin-left: 8px;
      padding: 2px 6px;
      @include breakpoints-min(md) {
        display: none;
      }
    }
    &__description {
      display: inline-block;
      font-size: 12px;
      font-weight: 400;
      line-height: 1.4;
      letter-spacing: 0.1em;
      margin: 4px 2px 2px;
      @include breakpoints-min(md) {
        font-size: 11px;
        text-align: justify;
        color: #757473;
        margin: 0 0 8px;
      }
    }
    &__size {
      font-size: 10px;
      font-weight: 400;
      line-height: 1.3;
      letter-spacing: 0.02em;
      margin: 4px 2px 4px;
      @include breakpoints-min(md) {
        line-height: 1.4;
        letter-spacing: 0.14em;
        text-align: center;
        color: #757473;
        margin: 0 0 6px;
      }
    }
    &__price {
      font-weight: 400;
      line-height: 1;
      margin: 8px 2px 4px;
      @include breakpoints-min(md) {
        text-align: center;
        margin: 0;
      }
      &__title {
        display: inline-block;
        font-size: 10px;
        letter-spacing: 0.08em;
        margin-right: 8px;
        @include breakpoints-min(md) {
          font-size: 10px;
          color: #757473;
          margin-right: 12px;
        }
      }
      &__num {
        display: inline-block;
        font-size: 14px;
        font-weight: 500;
        color: #000;
        @include breakpoints-min(md) {
          font-family: $serif;
          font-size: 15px;
        }
      }
      &__jpy {
        display: inline-block;
        font-size: 10px;
        font-weight: 500;
        margin-left: 2px;
        @include breakpoints-min(md) {
          font-family: $serif;
          font-size: 10px;
          font-weight: 500;
          color: #423f3d;
          margin-left: 4px;
        }
      }
    }
    &__enlarge-button {
      cursor: pointer;
      display: block;
      position: absolute;
      top: 5px;
      right: 13px;
      z-index: 3;
      border-radius: 50%;
      width: 22px;
      height: 22px;
      &::before,
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
      }
      &::before {
        z-index: 2;
        background-color: #fff;
        width: 20px;
        height: 20px;
      }
      &::after {
        transition: 0.25s linear;
        z-index: 1;
        background-color: #d4d2d2;
        width: 22px;
        height: 22px;
      }
      @include breakpoints-min(md) {
        top: -20px;
        right: 0;
        width: 42px;
        height: 42px;
        &::before {
          width: 40px;
          height: 40px;
        }
        &::after {
          width: 44px;
          height: 44px;
        }
        @include hover() {
          &::after {
            width: 48px;
            height: 48px;
          }
        }
      }
    }
    &__enlarge-icon {
      position: absolute;
      z-index: 3;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 10px;
      height: 10px;
      &::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 50%;
        border: 1px solid $oc-gray-9;
        width: 8px;
        height: 8px;
      }
      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 8px;
        left: 6px;
        transform: rotate(45deg);
        background-color: $oc-gray-9;
        width: 3px;
        height: 1px;
      }
      @include breakpoints-min(md) {
        width: 16px;
        height: 16px;
        &::before {
          width: 14px;
          height: 14px;
        }
        &::after {
          top: 13px;
          left: 11px;
          width: 5px;
        }
      }
    }
    &__img-overlay {
      cursor: pointer;
      position: absolute;
      top: 8px;
      left: 16px;
      z-index: 3;
      width: calc(100% - 32px);
      height: calc(100% - 16px);
      @include breakpoints-min(md) {
        display: none;
      }
    }
    &__submit {
      display: flex;
      width: 100%;

      @include breakpoints-min(md) {
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .kashira-item__button {
        margin: 0 16px;
      }
    }

    &__img {
      display: flex;
      justify-content: center;
      align-items: center;
      transition: $transition;
      position: relative;
      line-height: 1;
      width: 136px;
      padding: 8px;
      @include active() {
        transform: scale(1.1);
      }
      @include breakpoints-min(md) {
        width: auto;
        padding: 0 12px;
        @include active() {
          transform: scale(1);
        }
      }
    }
    .item-img {
      display: block;
      position: relative;
      z-index: 1;
      background-color: #fff;
      font-size: 0;
      width: calc(100% - 16px);
      padding: 8px;
      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        border: 1px solid rgba($oc-gray-8, 0.1);
        width: 100%;
        height: 100%;
      }
      @include breakpoints-min(md) {
        top: auto;
        left: auto;
        transform: none;
        width: auto;
        &::after {
          display: none;
        }
      }
    }
  }

  .app-gogatsu {
    .kashira-item-select__item{
      &.is-active {
        box-shadow: none;
        background-color: #fff2f4;
        .kashira-item__button {
          border-color: $gogatsu-accent-color;
          background-color: $gogatsu-accent-color;
          color: #fff;
          @include hover() {
            border-color: $gogatsu-accent-color;
            background-color: $gogatsu-accent-color;
            color: #fff;
          }
        }
        .kashira-item__enlarge-button {
          &::after {
            background-color: $gogatsu-accent-color-disabled;
          }
          @include breakpoints-min(md) {
            &::after {
              background-color: #d4d2d2;
            }
          }
        }
        .item-img {
          &::after {
            border: 1px solid rgba($gogatsu-accent-color, 0.5);
          }
        }
        @include breakpoints-min(md) {
          background-color: transparent;
        }
      }
      &__soldout {
        background-color: $gogatsu-accent-color;
        color: #fff;
      }
      &__button {
        &.is-soldout {
          border-color: $gogatsu-accent-color;
          background-color: $gogatsu-accent-color;
          color: #fff !important;
          @include hover() {
            border-color: $gogatsu-accent-color-hover;
            background-color: $gogatsu-accent-color-hover;
            color: #fff;
          }
          @include active() {
            border: 1px solid $gogatsu-accent-color-active;
            background-color: $gogatsu-accent-color-active;
            color: #fff;
          }
        }
        @include breakpoints-min(md) {
          display: block;
          @include hover() {
            border-color: $gogatsu-accent-color;
            color: $gogatsu-accent-color;
          }
          @include active() {
            border: 1px solid $gogatsu-accent-color;
            background-color: $gogatsu-accent-color-bg;
            color: $gogatsu-accent-color;
          }
        }
      }

    }

  }
</style>
